export default "__VITE_ASSET__BVJJVHgE__"